import Reflux from 'reflux';
import ControlsActionsFactory from './controls-actions-factory';
const StoreCache = {};
/*
    ControlStore

    Manages the state of the Video player's controls.
*/
class ControlStore extends Reflux.Store {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.video = props["config-id"];
    this.ControlsActions = ControlsActionsFactory.get(props["config-id"], props.route);
    this.listenables = [this.ControlsActions];
  }
  getInitialState() {
    return {
      isReady: false,
      isPause: true,
      currentTime: 0,
      duration: 0,
      volume: 0,
      isFullscreen: false
    };
  }
  onInit(state) {
    this.setState(state);
  }
  onSetPause(flag) {
    this.setState({
      isPause: flag
    });
  }
  onSetCurrentTime(currentTime) {
    currentTime = isNaN(currentTime) ? this.state.currentTime : currentTime;
    this.setState({
      currentTime: currentTime
    });
  }
  onSetDuration(duration=this.state.duration) {
    this.setState({
      duration: duration
    });
  }
  onSetFullscreen(flag=false) {
    this.setState({
      isFullscreen: flag
    });
  }
  onSetVolume(volume = 1) {
    this.setState({
      volume: volume
    });
  }
  onShow() {
    this.setState({
      isReady: true
    });
  }
}

ControlStore.get = function(config, route) {
    const key = `${route.location.pathname}${config["config-id"]}`;
    if(StoreCache[key]==null) {
      StoreCache[key] = new ControlStore(config);
    }
    return StoreCache[key]
};
ControlStore.clearCache = function() {
  Object.keys(StoreCache).forEach((key)=> {
    ControlsActionsFactory.clearCache();
    delete StoreCache[key];
  });
}


export default ControlStore;



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/controls-store.js